import axios, { AxiosResponse, AxiosInstance, AxiosRequestConfig, AxiosRequestHeaders, AxiosError } from 'axios';
import { ResponseHttp } from '../interfaces/response-http.interface';
import { HttpStatusCode } from '../enums/http-response.enum';

export class HttpCall {
	private readonly _axiosInstance: AxiosInstance = axios.create();

	private emitHttpErrorEvent(status: number, url: string, method: string): void {
		if (typeof globalThis !== 'undefined' && globalThis.document?.readyState === 'complete') {
			const event: CustomEvent = new CustomEvent('smartlinks-widget-http-error', {
				detail: { status, url, method, source: 'smartlinks-widget' },
			});

			globalThis.dispatchEvent(event);
		}
	}

	public async get<T>(url: string, customHeaders?: AxiosRequestHeaders): Promise<ResponseHttp<T>> {
		try {
			const config: AxiosRequestConfig = {
				headers: {
					...customHeaders,
					'Content-Type': 'application/json',
				},
			};

			const response: AxiosResponse<T> = await this._axiosInstance.get(url, config);
			return { response: response.data };
		} catch (error) {
			const axiosError = error as AxiosError;
			if (axiosError?.response?.status === HttpStatusCode.Unauthorized) {
				this.emitHttpErrorEvent(HttpStatusCode.Unauthorized, url, 'GET');
			}

			return { error };
		}
	}

	public async post<T, U>(url: string, data: U, customHeaders?: AxiosRequestHeaders): Promise<ResponseHttp<T>> {
		try {
			const config = {
				headers: {
					...customHeaders,
					'Content-Type': 'application/json',
					Accept: 'application/json',
				},
			};

			const response: AxiosResponse<T> = await this._axiosInstance.post(url, { ...data }, config);
			return { response: response.data };
		} catch (error) {
			const axiosError = error as AxiosError;
			if (axiosError?.response?.status === HttpStatusCode.Unauthorized) {
				this.emitHttpErrorEvent(HttpStatusCode.Unauthorized, url, 'POST');
			}

			return { error };
		}
	}
}
